import { render, staticRenderFns } from "./Pluggy.vue?vue&type=template&id=a4e9040c&scoped=true&"
import script from "./Pluggy.vue?vue&type=script&lang=js&"
export * from "./Pluggy.vue?vue&type=script&lang=js&"
import style0 from "./Pluggy.vue?vue&type=style&index=0&id=a4e9040c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e9040c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4e9040c')) {
      api.createRecord('a4e9040c', component.options)
    } else {
      api.reload('a4e9040c', component.options)
    }
    module.hot.accept("./Pluggy.vue?vue&type=template&id=a4e9040c&scoped=true&", function () {
      api.rerender('a4e9040c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Importacao/Pluggy/Pluggy.vue"
export default component.exports